import { WorkshopPlannerService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const workshopTechnicianAvailableSlotsQueryKey = 'WorkshopTechnicianAvailableSlots';

export interface WorkshopTechnicianAvailableSlotsInput {
  date: string;
  jobHours: number;
  technicianId: number;
}

export const useWorkshopTechnicianAvailableSlotsQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  input?: WorkshopTechnicianAvailableSlotsInput,
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof WorkshopPlannerService.getWorkshopPlannerJobsTechnicianAvailableSlots>>,
      QueryError,
      Awaited<ReturnType<typeof WorkshopPlannerService.getWorkshopPlannerJobsTechnicianAvailableSlots>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery(
    [workshopTechnicianAvailableSlotsQueryKey, ...(queryKey ?? []), input],
    () =>
      WorkshopPlannerService.getWorkshopPlannerJobsTechnicianAvailableSlots(
        input?.date,
        input?.jobHours,
        input?.technicianId
      ),
    options
  );
